<template lang="pug">
v-navigation-drawer.z-50(v-model="showDrawer" mobile-breakpoint="xs" width="400" temporary right app touchless :height="drawerHeight")
  div.sticky.top-0.white.pt-5.px-5.pb-2.z-1
    v-btn(v-if="step" icon @click="step = 0" small)
      v-icon(color="neutral700") mdi-arrow-left
    v-btn(v-else icon @click="closeDrawer" small)
      v-icon(color="neutral700") mdi-close
  v-window(v-model="step" touchless)
    v-window-item(:value="0")
      div.px-5.pb-5.pt-3
        div.d-flex.align-center
          div.text-xl.font-medium.neutral700--text +{{ member.phone }}
          v-spacer
          v-btn(icon @click="step = 1" small)
            v-icon(color="neutral500" size="20") $yzi-edit-05
        div.d-flex.align-center.mt-3
          div.text-sm.font-semibold.neutral700--text Name
          v-spacer
          div.text-sm.neutral700--text {{ member.name }}
        div.d-flex.align-center.mt-2
          div.text-sm.font-semibold.neutral700--text Total spend
          v-spacer
          div.text-sm.neutral700--text {{ member.total_spend | displayPrice($currency) }}
        v-progress-linear.my-3(v-if="isFetching" width="3" rounded color="primary" indeterminate)
        template(v-else)
          template(v-if="settings.loyalty_system === 'stamps'")
            div.d-flex.align-center.mt-2
              div.text-sm.font-semibold.neutral700--text Stamps
              v-spacer
              div.d-flex.align-center
                template(v-for="stamp in stampRewards")
                  v-icon.ml-2(v-if="stamp.reward" size="12" :color="stamp.collected ? 'success500' : 'neutral400'") $yzi-gift-02
                  v-avatar.ml-2(v-else size="8" :color="stamp.collected ? 'success500' : 'neutral400'")
          template(v-if="settings.loyalty_system === 'points'")
            div.d-flex.align-center.mt-2
              div.text-sm.font-semibold.neutral700--text Points
              v-spacer
              div.text-sm.font-medium.neutral700--text {{ member.collected }}
      v-divider.neutral300

      div.px-5.pb-5.pt-4
        div.text-xs.font-semibold.neutral500--text Offers
        div.d-flex.justify-center.mt-16(v-if="isFetchingOffers")
          v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
        template(v-else v-for="(offer, idx) in offers")
          div(:key="`off-${idx}`")
            v-divider(v-if="idx")
            div.py-3
              div.d-flex.align-center
                div
                  div.text-sm.font-medium.neutral700--text {{ offer.offer.name }}
                  div.d-flex.align-center
                    div.text-xs.neutral700--text(v-if="offer.expired_at") Use before {{ offer.expired_at | humanizeDate }}
                    div.text-xs.neutral700--text(v-else) No end date
                    v-chip.ml-3(v-if="offer.redeemable_qty < 10" color="neutral300" small) 
                      v-icon(left size="16" color="neutral500") $yzi-alert-circle
                      | {{ offer.redeemable_qty }} left
                //- v-spacer
                //- y-button(label="Apply" underline size="sm")

      v-footer.white.px-5.pb-5.pt-3(app padless)
        y-button(:label="`Collect ${settings.loyalty_system}`" block size="md" @click="showCollectValueDialog = true")
        y-button.mt-3(label="Redeem reward" block size="md" @click="showRedeemRewardDialog = true")
        y-button.mt-3(label="WhatsApp" outlined prepend-icon="mdi-whatsapp" block size="md" @click="openWhatsapp(member)")

        
    v-window-item(:value="1")
      div.px-5.pb-5.pt-3
        v-form(ref="form")
          div.text-xl.font-medium.neutral700--text Edit info
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
          phone-input.mt-2(v-model="member.phone" background-color="neutral300" disabled)
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('name') }}
          v-text-field.text-sm.mt-2.round-xl(v-model="name" placeholder="Enter name" background-color="neutral100" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
          template(v-if="marketingSetting.plan === 'standalone'")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('date_of_birth') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="dob" placeholder="Enter date of birth" type="date" outlined dense height="48" hide-details="auto" :rules="rules.not_empty")
          div.d-flex.align-center.mt-8
            v-spacer
            y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="step = 0")
            y-button(label="Save" size="sm" dark :loading="isLoading" @click="saveData")

  .dialogs
    collect-value-dialog(v-if="showCollectValueDialog" :open.sync="showCollectValueDialog" :loyaltySystem="settings.loyalty_system" :member="member" :rewards-position="rewardsPosition" @refetch="updateLoyalty" @redeem="handleRedeemReward")
    redeem-reward-dialog(v-if="showRedeemRewardDialog" :open.sync="showRedeemRewardDialog" :loyaltySystem="settings.loyalty_system" :member="member" :rewards-position="rewardsPosition" @refetch="updateLoyalty")

</template>

<script>
import { mapGetters } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'
import RedeemRewardDialog from "@/components/clinic/checkout/marketing/redeem/reward/RedeemRewardDialog.vue"
import CollectValueDialog from "@/components/clinic/checkout/marketing/collecting/CollectValueDialog.vue"

export default {
  props: ['open', 'member', 'settings'],
  components: { PhoneInput, RedeemRewardDialog, CollectValueDialog },
  data: () => ({
    isLoading: false,
    isFetching: false,
    isFetchingOffers: false,
    showCollectValueDialog: false,
    showRedeemRewardDialog: false,
    step: 0,
    name: null,
    dob: null,
    loyalty: {},
    offers: [],
    rules: {
      not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
    },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      displaySize: 'ui/getDisplaySize',
      marketingSetting: "marketing/getMarketingSettings"
    }),
    showDrawer: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    stampRewards () {
      let stamps = []
      if (this.loyalty.system === 'stamps') {
        for (let i = 1; i <= 10; i++) {
          let stamp = { number: i, collected: false, reward: false }
          if (i <= this.member.collected) {
            stamp.collected = true
          }
          if (this.loyalty.rewards.find(f => f.tier_value === i)) {
            stamp.reward = true
          }
          stamps.push(stamp)
        }
      }
      return stamps
    },
    rewardsPosition() {
      return this.loyalty.rewards.map(reward => reward.tier_value) || []
    },
    allFilters () {
      const filters = []
      if (this.providersFilter?.items) {
        let list = this.providersFilter?.items.join(',')
        filters.push({ key: 'providers', value: list })
      }
      if (this.servicesFilter?.items) {
        let list = this.servicesFilter.items.join(',')
        filters.push({ key: 'services', value: list })
      }
      if (this.paymentFilter?.items) {
        let list = this.paymentFilter.items.join(',')
        filters.push({ key: 'paid', value: list })
      }
      if (this.dateFilter?.before) {
        filters.push({ key: 'date__lt', value: this.dateFilter.before })
      }
      if (this.dateFilter?.after) {
        filters.push({ key: 'date__gt', value: this.dateFilter.after })
      }
      if (this.dateFilter?.exact) {
        filters.push({ key: 'date', value: this.dateFilter.exact })
      }
      if (this.dateFilter?.between) {
        filters.push({ key: 'date__gte', value: this.dateFilter.between.start })
        filters.push({ key: 'date__lte', value: this.dateFilter.between.end })
      }
      if (this.timeFilter?.before) {
        filters.push({ key: 'time__lt', value: this.timeFilter.before })
      }
      if (this.timeFilter?.after) {
        filters.push({ key: 'time__gt', value: this.timeFilter.after })
      }
      if (this.timeFilter?.exact) {
        filters.push({ key: 'time', value: this.timeFilter.exact })
      }
      if (this.timeFilter?.between) {
        filters.push({ key: 'time__gte', value: this.timeFilter.between.start })
        filters.push({ key: 'time__lte', value: this.timeFilter.between.end })
      }
      return filters
    },
    drawerHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '149vh'
        case 'x-small':
          return '133vh'
        case 'small':
          return '125vh'
        case 'medium':
          return '111vh'
        case 'large':
          return '100vh'
        case 'x-large':
          return '91vh'
        default:
          return '100vh'
      }
    }
  },
  mounted () {
    this.setData()
    this.fetchLoyalty()
    this.fetchOffers()
  },
  methods: {
    setData () {
      this.name = this.member.name
      this.dob = this.member.dob
    },
    fetchLoyalty () {
      this.isFetching = true
      this.$axios.get(`/loyalty/${this.company.slug}`)
        .then(resp => {
          this.loyalty = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchOffers () {
      this.isFetchingOffers = true
      this.$axios.get(`/marketing/${this.company.slug}/coupons`, { params: { loyalty_member: this.member.id, ordering: 'expired_at' } })
        .then(resp => {
          this.offers = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingOffers = false
        })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      const payload = {
        name: this.name,
      }
      if (this.marketingSetting.plan === 'standalone') {
        payload.dob = this.dob
      }
      this.$axios.patch(`/loyalty/${this.company.slug}/members/${this.member.id}`, payload)
        .then(resp => {
          this.$emit('update:member', resp.data)
          this.$emit('updated')
          this.step = 0
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleRedeemReward() {
      this.showRedeemRewardDialog = true
    },
    clearFilters () {
      this.providersFilter = {}
      this.servicesFilter = {}
      this.paymentFilter = {}
      this.dateFilter = {}
      this.timeFilter = {}
    },
    openDetail (page) {
      this.page = page
    },
    back () {
      this.page = 'main'
    },
    getFilterData (type) {
      switch (type) {
        case 'providers': {
          const length = this.providersFilter?.items?.length
          if (length) {
            return `${length} provider(s) selected`
          }
          break
        }
        case 'services': {
          const length = this.servicesFilter?.items?.length
          if (length) {
            return `${length} service(s) selected`
          }
          break
        }
        case 'payment': {
          const length = this.paymentFilter?.items?.length
          if (length) {
            return `${length} payment status(es) selected`
          }
          break
        }
        case 'date': {
          let changes = []
          for (const key in this.dateFilter) {
            const val = this.dateFilter[key]
            const name = this.getNameFromFilterKey(key)
            if (val) {
              if (key === 'between') {
                changes.push(`${name} ${val.start} - ${val.end}`)
              } else {
                changes.push(`${name} ${val} `)
              }
            }
          }
          return changes.join('\n')
        }
        case 'time': {
          let changes = []
          for (const key in this.timeFilter) {
            const val = this.timeFilter[key]
            const name = this.getNameFromFilterKey(key)
            if (val) {
              if (key === 'between') {
                const startTime = this.convert24to12(val.start)
                const endTime = this.convert24to12(val.end)
                changes.push(`${name} ${startTime} - ${endTime}`)
              } else {
                const time = this.convert24to12(val)
                changes.push(`${name} ${time} `)
              }
            }
          }
          return changes.join('\n')
        }
        default:
          return null
      }
    },
    getNameFromFilterKey (key){
      switch(key) {
        case 'exact':
          return 'Exact'
        case 'before':
          return 'Before'
        case 'after':
          return 'After'
        case 'between':
          return 'In between'
      }
      return key
    },
    deleteFilter (type) {
      switch (type) {
        case 'providers':
          this.providersFilter = {}
          break
        case 'services':
          this.servicesFilter = {}
          break
        case 'payment':
          this.paymentFilter = {}
          break
        case 'date':
          this.dateFilter = {}
          break
        case 'time':
          this.timeFilter = {}
          break
      }
    },
    clickDone () {
      this.$emit('done', this.allFilters)
      this.showDrawer = false
    },
    openWhatsapp (member) {
      const phone = member.phone
      window.open(`https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(phone)}`)
    },
    updateLoyalty () {
      this.$emit('updated')
      this.closeDrawer()
    },
    closeDrawer () {
      this.showDrawer = false
      this.$emit('closed')
    },
    convert24to12 (timeString){
      var H = timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = (H < 12 || H === 24) ? "AM" : "PM";
      return `${h}${timeString.substr(2, 3)} ${ampm}`
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), 
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  box-shadow: unset !important;
}
.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
  max-height: 100% !important;
}
</style>